import { apiCall } from '../../../utils';

export const login = (email, password) =>
  apiCall({
    url: '/users/token/',
    method: 'post',
    data: { email, password },
  });
